import PropTypes from 'prop-types'

const Price = ({ currencyData, amount }) => {
  const { symbol = '' } = currencyData || {}
  let a = amount / 100
  a = a.toFixed(!Number.isInteger(a) * 2)
  return `${symbol}${a}`
}

Price.propTypes = {
  currencyData: PropTypes.object,
  amount: PropTypes.any,
}

export default Price
